import { render } from "./FavouriteJeans.vue?vue&type=template&id=8e741bb6"
import script from "./FavouriteJeans.vue?vue&type=script&lang=js"
export * from "./FavouriteJeans.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__